<template>
  <div
    class="shared-table-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Loading table"
  >
    <div
      v-for="rowKey in rowKeys"
      :key="rowKey"
      class="shared-table-skeleton__row"
    >
      <v-skeleton-loader
        v-for="columnKey in columnKeys"
        :key="`${rowKey}-${columnKey}`"
        type="text"
        class="shared-table-skeleton__cell"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SharedTableSkeleton",
};
</script>

<script setup>
import { computed } from "vue";

const props = defineProps({
  rowCount: {
    type: Number,
    default: 5,
  },
  columnCount: {
    type: Number,
    default: 4,
  },
  columnTemplate: {
    type: String,
    default: "2fr 1fr 1fr 80px",
  },
});

const safeRowCount = computed(() => {
  const count = Number(props.rowCount);
  return Number.isFinite(count) && count > 0 ? Math.floor(count) : 5;
});

const safeColumnCount = computed(() => {
  const count = Number(props.columnCount);
  return Number.isFinite(count) && count > 0 ? Math.floor(count) : 4;
});

const rowKeys = computed(() =>
  Array.from({ length: safeRowCount.value }, (_, index) => `row-${index + 1}`)
);

const columnKeys = computed(() =>
  Array.from({ length: safeColumnCount.value }, (_, index) => `col-${index + 1}`)
);

const resolvedColumnTemplate = computed(() => {
  const template = typeof props.columnTemplate === "string" ? props.columnTemplate.trim() : "";
  return template || "2fr 1fr 1fr 80px";
});
</script>

<style scoped>
.shared-table-skeleton {
  border-top: 1px solid #eaecf0;
}

.shared-table-skeleton__row {
  display: grid;
  grid-template-columns: v-bind(resolvedColumnTemplate);
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid #eaecf0;
}

.shared-table-skeleton__cell {
  max-width: 100%;
}
</style>
